import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class PermissionsApi {
  static getGroups(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.groups, { params });
  }

  static getUserGroups(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.groupsUser, { params });
  }

  static getAssignedUserForGroups(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.groups, { params });
  }

  static addUserToGroups(props) {
    const { id, params } = props;
    const groupings = params.map(group => ({
      user_id: id,
      group_id: group
    }));
    return axios.post(ApiEndpoints.groupsAssignUser, groupings);
  }

  static removeUserFromGroups(props) {
    const { params } = props;
    const groupings = params.map(group => ({ id: group }));
    return axios.delete(ApiEndpoints.groupsDeleteUser, { data: groupings });
  }
}

export default PermissionsApi;
